import React from "react";
import './generatingLoader.styles.scss';

const BouncingDotsLoader: React.FC = () => {
  return (
    <div className="generating-loader-container">
      <div className="generating-text">Generating</div>
      <div className="bouncing-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default BouncingDotsLoader;